<template>
    <div>
        <v-select
            v-model="selectedForm"
            label="name"
            placeholder="Search..."
            :class="{
                'is-invalid': !!error
            }"
            :options="forms"
            @search="onSearch"
        >
            <template slot="no-options">
                Start typing to search for a form
            </template>
        </v-select>

        <div class="invalid-feedback">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null
        },

        error: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            selectedForm: null,
            forms: []
        };
    },

    watch: {
        selectedForm() {
            this.$emit(
                'input',
                this.selectedForm ? this.selectedForm.id : null
            );
        }
    },

    async created() {
        const id = this.value;

        if (!id) {
            return;
        }

        try {
            this.selectedForm = await this.getForm(id);

            this.forms.push(this.selectedForm);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getForms: 'forms/index',
            getForm: 'forms/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.forms = this.selectedForm ? [this.selectedForm] : [];

                return;
            }

            loading(true);

            try {
                const { rows: forms } = await this.getForms({
                    search
                });

                if (
                    this.selectedForm &&
                    forms.every(form => form.id !== this.selectedForm.id)
                ) {
                    forms.push(this.selectedForm);
                }

                this.forms = forms;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
